import api from "../utils/api";

export const fetchINRInvestors = async ({
  search = "",
  page = 1,
  limit = 20,
} = {}) => {
  try {
    const params = {};
    if (search) params.search = search;
    params.page = page;
    params.limit = limit;
    console.log("Fetching INR investors with params:", params);
    const res = await api.get("/api/inr-investors", { params });
    console.log("INR investors service response:", res.data);
    return res.data;
  } catch (error) {
    console.error("INR investors service error:", error);
    console.error("Error response:", error.response?.data);
    throw error;
  }
};

export const addINRInvestor = async (data) => {
  const res = await api.post("/api/inr-investors", data);
  return res.data;
};

export const updateINRInvestor = async (id, data) => {
  const res = await api.put(`/api/inr-investors/${id}`, data);
  return res.data;
};

export const deleteINRInvestor = async (id) => {
  const res = await api.delete(`/api/inr-investors/${id}`);
  return res.data;
};

export const softDeleteINRInvestor = async (id, deleteReason = null) => {
  const res = await api.post(`/api/inr-investors/${id}/soft-delete`, {
    deleteReason,
  });
  return res.data;
};

export const fetchDeletedINRInvestors = async ({
  search = "",
  page = 1,
  limit = 20,
  sortBy = "deleted_at",
  sortOrder = "DESC",
} = {}) => {
  try {
    const params = {};
    if (search) params.search = search;
    params.page = page;
    params.limit = limit;
    params.sortBy = sortBy;
    params.sortOrder = sortOrder;

    console.log("Fetching deleted INR investors with params:", params);
    const res = await api.get("/api/inr-investors/deleted/records", { params });
    console.log("Deleted INR investors service response:", res.data);
    return res.data;
  } catch (error) {
    console.error("Deleted INR investors service error:", error);
    console.error("Error response:", error.response?.data);
    throw error;
  }
};

export const restoreINRInvestor = async (historyId) => {
  const res = await api.post(`/api/inr-investors/deleted/${historyId}/restore`);
  return res.data;
};

export const permanentlyDeleteINRInvestor = async (historyId) => {
  const res = await api.delete(
    `/api/inr-investors/deleted/${historyId}/permanent`
  );
  return res.data;
};
